module.exports = __webpack_public_path__ + "img/-LV1APN3z8uB6o3RvU3z.7b929519.jpg";